import every from 'lodash/every';
import i18n from './i18n';
import {findProjectMemberInOxygenMappingById} from './userHelpers';
import {HQ_COMPANY_TYPE, HQ_ROLE_TYPE, HQ_USER_TYPE} from '../constants/hq-types';
import {sortAlphabeticallyByPath} from './sortingHelpers';

const entityTypeToPlural = {
  [HQ_USER_TYPE]: 'users',
  [HQ_COMPANY_TYPE]: 'companies',
  [HQ_ROLE_TYPE]: 'roles'
};

export const getOxygenEntityInfo = (oxygen, type, id) => (oxygen[entityTypeToPlural[type]] || {})[id] || null;

export const getSimpleGroupedEntities = ({users = [], companies = [], roles = []}) => {
  const groupedEntities = [];
  // Users
  groupedEntities.push([i18n.t('assignment.user'), users]);
  // Roles
  groupedEntities.push([i18n.t('assignment.role'), roles]);

  // Companies
  groupedEntities.push([i18n.t('assignment.company'), companies]);

  return every(groupedEntities, group => group[1].length === 0) ? [] : groupedEntities;
};

const addEntityToListIfNeeded = (list, entity) => {
  if (entity && !list.some(item => item.id === entity.id)) {
    return sortAlphabeticallyByPath([...list, entity], 'name');
  }
  return list;
};

export const addCurrentOptionToGroupIfNeeded = (oxygenLists, entity) => {
  if (!entity?.oxygenType) {
    return oxygenLists;
  }
  const key = entityTypeToPlural[entity.oxygenType];
  return {
    ...oxygenLists,
    [key]: addEntityToListIfNeeded(oxygenLists[key], entity)
  };
};

// Assignees can come from:
// SelectDropdown  - which means we get the entire assignee object as part of an array and we don't need to do anything
// Url query params - which means that we get either one string (in case of one assignee) or an array of strings. For this scenario we need to find the entity from oxygenMapping
export const getAssignees = (rawAssignees, oxygenMapping) => {
  const assignees = rawAssignees.constructor === Array ? [].concat(rawAssignees) : [rawAssignees];

  for (let i = 0; i < assignees.length; i++) {
    const currentAssignee = assignees[i];
    // If currentAssignee is string it means that it's just the Id and not the actual assignee object so we need to find it in the oxygenMapping
    // Otherwise, we don't need to mutate assignees[i] since it already holds the assignee object
    if (currentAssignee.constructor === String) {
      assignees[i] = findProjectMemberInOxygenMappingById(currentAssignee, oxygenMapping);
    }
  }

  return assignees;
};
